import React, {useEffect, useState} from "react";
import {exibirMensagemErro, exibirMensagemSucesso, HttpVerbo, xfetch} from "../util";
import {useParams} from "react-router-dom";
import {BotaoAdicionar, BotaoExcluir} from './botao/botao-mantine';
import CardPadrao from './card/card-padrao';
import {Grid, NumberInput, Table, TextInput} from '@mantine/core';
import {COL_RESP_2, COL_RESP_8} from '../config/constantes/constantes-mantine';
import {AcaoEixo} from "../tipos/acao-eixo";
import {Meta} from "../tipos/meta";

export default function CadastrarAcaoEixo({setIsCarregando, meta}: {setIsCarregando: Function, meta: Meta}) {

  const parametros = useParams()
  const idMeta = parametros.idMeta
  const [objeto, setObjeto] = useState<AcaoEixo>(new AcaoEixo())

  const [acoes, setAcoes] = useState<AcaoEixo[]>([])

  function carregarAcoes() {
    setIsCarregando(true)
    xfetch(`/meta/${idMeta}/acao`, {}, HttpVerbo.GET)
      .then(res => res.json())
      .then(dados => {
        setAcoes(dados)
      })
      .finally(() => setIsCarregando(false))
  }

  function validacaoCadastro() {
    if (!objeto.numero && !isNaN(objeto.numero)) {
      exibirMensagemErro("Um número precisa ser informado")
      throw 'ERROR';
    }

    if (!objeto.descricao) {
      exibirMensagemErro("Uma descrição precisa ser informada")
      throw 'ERROR'
    }

    if (!idMeta) {
      exibirMensagemErro("Meta não encontrada. Recarregue a página")
      throw 'ERROR'
    }
  }

  function cadastrar() {
    validacaoCadastro();
    setIsCarregando(true)
    xfetch(`/meta/${idMeta}/acao`, objeto, HttpVerbo.POST)
      .then(res => res.json())
      .then(dados => {
        exibirMensagemSucesso("Ação cadastrada com sucesso.")
        setObjeto(new AcaoEixo())
        carregarAcoes()
      })
      .finally(() => setIsCarregando(false))
  }

  function excluir(idAcao: number) {
    let resposta = window.confirm("Deseja realmente excluir");

    if (resposta) {
      setIsCarregando(true)
      xfetch(`/meta/${idMeta}/acao/delete`, {idAcao: idAcao}, HttpVerbo.POST)
        .then(res => {
          exibirMensagemSucesso("Ação removida com sucesso")
          carregarAcoes()
        })
        .finally(() => setIsCarregando(false))
    }
  }

  useEffect(() => {
    carregarAcoes()
  }, [])

  return (
    <CardPadrao titulo={"Ações"}>
      <Grid>
        <Grid.Col span={COL_RESP_2}>
            <NumberInput
              label={"Número"}
              placeholder="Número"
              value={objeto.numero}
              onChange={(e) => setObjeto({...objeto, numero: Number(e)})}/>
        </Grid.Col>
        <Grid.Col span={COL_RESP_8}>
          <TextInput
              label="Descrição"
              placeholder="Descrição"
              value={objeto.descricao}
              onChange={(e) => setObjeto({...objeto, descricao: e.target.value.toUpperCase()})}/>
        </Grid.Col>
        <Grid.Col span={COL_RESP_2} style={{alignSelf: "self-end"}}>
            <BotaoAdicionar onClick={cadastrar}/>
        </Grid.Col>
      </Grid>
      <Table withTableBorder mt={40} mb={10}>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Nº</Table.Th>
            <Table.Th>Nome</Table.Th>
            <Table.Th>Ação</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {acoes.map((v, k) => {
            return (
                <Table.Tr key={k}>
                  <Table.Td>{v.numero}</Table.Td>
                  <Table.Td>{v.descricao}</Table.Td>
                  <Table.Td><BotaoExcluir size={"xs"} onClick={(e) => excluir(v.id)}/></Table.Td>
                </Table.Tr>
            )
          })}
        </Table.Tbody>
      </Table>
    </CardPadrao>
  )
}